import React, { useState } from 'react';
import './FAQPage.css';

const FAQPage = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const faqData = {
    general: {
      title: "General Questions",
      questions: [
        {
          id: "what-is-ooowap",
          question: "What is Ooowap?",
          answer: "Ooowap is a peer-to-peer trading platform for purse enthusiasts to trade their favorite bags. Users can upload their purses, browse available items, and arrange temporary trades with other community members."
        },
        {
          id: "how-trading-works",
          question: "How does the trading system work?",
          answer: `1. **Upload**: Users upload photos and details of their purses
2. **Browse**: Explore purses from other users in the community
3. **Trade Request**: Send a trade request with your bag for someone else's
4. **Accept/Reject**: The other user can accept or reject your trade request
5. **Exchange**: Arrange for pickup or ship your bags
6. **Complete**: Return items after the agreed duration`
        },
        {
          id: "is-it-free",
          question: "Is it free to use?",
          answer: "The platform charges fees for trades:\n- **Site Fee**: Price listed by borrow (paid by both users)\n- **Delivery Fee**: Pick up- Varies based on location, variable for shipping (based on distance/carrier)\n- **Item Value Hold**: The value of the other person's item is held as security"
        }
      ]
    },
    account: {
      title: "Account & Registration",
      questions: [
        {
          id: "create-account",
          question: "How do I create an account?",
          answer: `1. Click "Login" in the top navigation
2. Click "Sign Up" to create a new account
3. Fill in your details: name, email, password, phone, address, and closet name
4. Complete the registration process`
        },
        {
          id: "account-info",
          question: "What information do I need to provide?",
          answer: "- **Personal**: Name, email, password, phone number\n- **Address**: Street address, apartment/unit (optional), city, state, ZIP code (for shipping calculations)\n- **Store Details**: Your closet/store name for display"
        },
        {
          id: "change-account-info",
          question: "Can I change my account information?",
          answer: "Yes, you can update your profile information in the \"My Account\" section of your dashboard."
        }
      ]
    },
    items: {
      title: "Item Management",
      questions: [
        {
          id: "upload-purse",
          question: "How do I upload a purse?",
          answer: `1. Log in to your account
2. Click "Upload Bag" or go to your dashboard
3. Upload photos of your purse (main image + additional photos)
4. Fill in details: name, brand, size, condition, description
5. Submit for admin approval`
        },
        {
          id: "photo-requirements",
          question: "What photos should I include?",
          answer: "- **Main Photo**: Clear front view of the purse\n- **Additional Photos**: Different angles, interior, hardware, any wear/tear\n- **High Quality**: Good lighting, clear focus, no blurry images"
        },
        {
          id: "approval-time",
          question: "How long does approval take?",
          answer: "Items are reviewed by admins and typically approved within 24-48 hours. You'll receive a notification when your item is approved."
        },
        {
          id: "edit-items",
          question: "Can I edit my items after uploading?",
          answer: "Yes, you can edit item details, add photos, or update descriptions from your dashboard."
        }
      ]
    },
    trading: {
      title: "Trading Process",
      questions: [
        {
          id: "request-trade",
          question: "How do I request a trade?",
          answer: `1. Browse available purses
2. Click on a purse you're interested in
3. Click "Request Trade"
4. Select your purse to trade
5. Choose delivery method (pickup or shipping)
6. Set trade duration (3-30 days)
7. Add a message explaining why you want to trade
8. Submit your request`
        },
        {
          id: "delivery-options",
          question: "What delivery options are available?",
          answer: "- **Pickup**: company Driver will pickup and drop off to your location (both users pay pickup fee)\n- **Shipping**: Mail the items (shipping costs calculated based on distance/carrier)"
        },
        {
          id: "trade-duration",
          question: "How long can trades last?",
          answer: "Trades can last anywhere from 1 day to 30 days. You set the duration when creating the trade request."
        },
        {
          id: "cancel-trade",
          question: "Can I cancel a trade?",
          answer: "only if its before acceptance\n- **Before acceptance**: Cancel anytime\n- **After acceptance**: will result in monetary penalty"
        }
      ]
    },
    financial: {
      title: "Financial System",
      questions: [
        {
          id: "add-money",
          question: "How do I add money to my account?",
          answer: `1. Go to your dashboard
2. Click "Add Funds"
3. Choose payment method:
   - **Stripe**: Credit/debit card (debit cards only)
   - **Manual Deposit**: CashApp, Zelle, or other methods`
        },
        {
          id: "payment-methods",
          question: "What payment methods are accepted?",
          answer: "- **Stripe**: Debit cards only (credit cards are not accepted)\n- **Manual Deposits**: CashApp, Zelle,"
        },
        {
          id: "no-credit-cards",
          question: "Why are credit cards not accepted?",
          answer: "The platform only accepts debit cards through Stripe for security and fraud prevention reasons."
        },
        {
          id: "withdraw-money",
          question: "Can I withdraw money?",
          answer: "Yes, you can withdraw funds to:\n- CashApp\n- Zelle\n\n**Withdrawal Limits:**\n- **Minimum**: $5.00\n- **Daily Maximum**: $500.00\n- **Processing Time**: 1-3 business days"
        }
      ]
    },
    safety: {
      title: "Safety & Security",
      questions: [
        {
          id: "is-trading-safe",
          question: "Is trading safe?",
          answer: "The platform includes several safety features:\n- **Verified Users**: All users must provide real information\n- **Item Value Holds**: Financial security for both parties\n- **Admin Oversight**: Dispute resolution and monitoring\n- **Reviews**: Community feedback system"
        },
        {
          id: "feel-unsafe",
          question: "What should I do if I feel unsafe?",
          answer: "- **Stop Communication**: Cease contact with the other user\n- **Create Dispute**: Report the issue immediately\n- **Contact Admin**: Reach out for assistance\n- **Document Everything**: Save messages and photos"
        },
        {
          id: "meet-strangers",
          question: "Should I meet strangers in person?",
          answer: "No, absolutely not. \n\n-under no circumstances are you required or encouraged to meet.\n\n-all communication should be done strictly on the site only."
        }
      ]
    },
    support: {
      title: "Getting Help",
      questions: [
        {
          id: "contact-admin",
          question: "How do I contact admin?",
          answer: "- **Email**: contactooowap@gmail.com\n- **Dashboard Messages**: Use the messages section\n- **Dispute System**: Create a dispute for urgent issues"
        },
        {
          id: "admin-help",
          question: "What can admins help with?",
          answer: "- **Account Issues**: Login problems, password resets\n- **Trade Problems**: Disputes, refunds, cancellations\n- **Technical Support**: Website issues, upload problems\n- **Policy Questions**: Rules, guidelines, violations"
        },
        {
          id: "response-time",
          question: "How quickly will I get a response?",
          answer: "- **Email**: Within 24-48 hours\n- **Dashboard Messages**: Within 24 hours\n- **Urgent Issues**: Disputes and safety concerns are prioritized\n- **Technical Problems**: Usually resolved within 24 hours"
        }
      ]
    }
  };

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about the Ooowap trading platform</p>
        </div>

        <div className="faq-content">
          {Object.entries(faqData).map(([sectionKey, section]) => (
            <div key={sectionKey} className="faq-section">
              <h2 className="faq-section-title">{section.title}</h2>
              <div className="faq-questions">
                {section.questions.map((item) => (
                  <div key={item.id} className="faq-item">
                    <button
                      className={`faq-question ${openSections[item.id] ? 'open' : ''}`}
                      onClick={() => toggleSection(item.id)}
                    >
                      <span>{item.question}</span>
                      <i className={`fas fa-chevron-${openSections[item.id] ? 'up' : 'down'}`}></i>
                    </button>
                    {openSections[item.id] && (
                      <div className="faq-answer">
                        <div className="faq-answer-content">
                          {item.answer.split('\n').map((line, index) => (
                            <p key={index}>
                              {line.includes('**') ? (
                                line.split('**').map((part, partIndex) => 
                                  partIndex % 2 === 1 ? <strong key={partIndex}>{part}</strong> : part
                                )
                              ) : (
                                line
                              )}
                            </p>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <div className="faq-contact">
            <h3>Still have questions?</h3>
            <p>Contact us at <a href="mailto:contactooowap@gmail.com">contactooowap@gmail.com</a></p>
            <p className="faq-updated">Last Updated: January 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
